module.exports = __webpack_public_path__ + "static/7d-303e2c75bb980e8cbc18793e97aa0257.jpg";